<script>
    const icons = {
        time: 'fa fa-clock',
        date: 'fa fa-calendar',
        up: 'fa fa-arrow-up',
        down: 'fa fa-arrow-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-calendar-check',
        clear: 'fa fa-trash-alt',
        close: 'fa fa-times-circle'
    }

    export default {
        name: 'ClauseMixin',
        props: {
            siteid: {
                type: Number,
                default: null,
            },
            id: {
                type: Number,
                default: null,
            },
            /* group: null, */
            content: {
                type: Object,
                default: null,
            },
        },
        data: function() {
            return { 
                loading: true,
                startconfig: {
                    maxDate: moment().endOf('d'),
                    format: 'DD.MM.YYYY',
                    locale: 'ru',
                    useCurrent: false,
                    icons: icons, 
                },
                endconfig: {
                    maxDate: moment().endOf('d'),
                    format: 'DD.MM.YYYY',
                    locale: 'ru',
                    useCurrent: false,
                    icons: icons,
                },
                tab: '',
                start: this.content.start ? moment(this.content.start) : moment().subtract(30, 'days').endOf('d'),
                end: this.content.end ?  moment(this.content.end) : moment().endOf('d'),
                start_: this.content.start ? moment(this.content.start) :  moment().subtract(30, 'days').endOf('d'),
                end_: this.content.end ?  moment(this.content.end) : moment().endOf('d'),
            }
        },
        mounted: function() {
            this.loading = false;
            this.emitChange();
        },
        methods: {
            setTab: function(tab) {
                this.tab = tab;
                this.emitChange();
            },
            updateDate: function(e, dateType) {
                if (dateType === 'start'){
                    this[dateType]=e.date.endOf('d')
                } else {
                    this[dateType]=e.date.endOf('d');
                }
                this.emitChange();
            },
            validateDate: function() {
                let valid = true;
                let start = null;
                let end = null;

                if (!this.start || !this.end) {
                    valid = false;
                } else {
                    start = this.start;
                    end = this.end;
                }

                if (valid) {
                    return {
                        start: start,
                        end: end
                    };
                } else {
                    return {}
                }
            },
        },
    }
</script>
